export default __webpack_public_path__ + "static/media/Muskmelon.8ab9b0aa.jpg";